import React from "react";

export function EmptyState({ icon = "fa-search", title, hint }) {
  return (
    <div className='bh-empty'>
      <i className={`fa ${icon} bh-empty__icon`} aria-hidden='true'></i>
      <p className='bh-empty__title'>{title}</p>
      {hint && <p className='bh-empty__hint'>{hint}</p>}
    </div>
  );
}

export function SkeletonRows({ count = 4 }) {
  return (
    <div className='bh-skeleton-list' aria-hidden='true'>
      {Array.from({ length: count }).map((_, i) => (
        <div className='bh-skeleton-row' key={i}>
          <span className='bh-skeleton bh-skeleton--circle' />
          <span className='bh-skeleton-lines'>
            <span className='bh-skeleton bh-skeleton--line' />
            <span className='bh-skeleton bh-skeleton--line bh-skeleton--short' />
          </span>
        </div>
      ))}
    </div>
  );
}

export default EmptyState;
